import { createPortal } from 'react-dom';

/**
 * Portal component for rendering content outside the normal DOM hierarchy
 * @param {Object} props Component props
 * @param {boolean} props.isOpen Whether the portal content should be rendered
 * @param {React.ReactNode} props.children Content to render in the portal
 * @returns {React.ReactPortal | null} Portal content or null if closed
 */
export default function Portal({ isOpen, children }) {
  if (!isOpen) return null;
  return createPortal(children, document.body);
}
